export default __webpack_public_path__ + "static/media/alart.3cd89495.svg";